import { GetUserRelatedModels, GetUserRelatedModelsResponse, GetPaginatedUsersParams, GetPaginatedUsersPayload, GetPaginatedUsersResponse, PaginatedUsers } from "config/types/dxc.types";
import axiosV2 from "utils/axios";

export const getQuery = <T extends Record<string, unknown | undefined>>(
    params: T,
): string => {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(item => {
        const [key, value] = item;
        if (value === undefined) return;
        const formattedValue = typeof value !== 'string' ? String(value) : value;
        searchParams.append(key, formattedValue);
    });
    return searchParams.toString();
};

export const getRelatedModelsById =
    async (): Promise<GetUserRelatedModels> => {
        try {
            const response = await axiosV2.get<GetUserRelatedModelsResponse>(
                `/dxc/roles-ous`,
            );
            return response.data.data;
        } catch (error) {
            console.error('User | getRelatedModelsById', error);
            return { roles: [], ous: [] };
        }
    };

export const getAllActiveUsers = async (
    params: GetPaginatedUsersParams,
    payload: Partial<GetPaginatedUsersPayload> = {},
): Promise<PaginatedUsers> => {
    const query = getQuery(params);
    try {
        const response = await axiosV2.post<GetPaginatedUsersResponse>(
            `/dxc/users?${query}`,
            payload,
        );
        return response.data.data;
    } catch (error) {
        console.error('User | getAllActiveUsers', error);
        return { users: [], total: 0 };
    }
};
